// extracted by mini-css-extract-plugin
export default {"nav_button":"Menu_nav_button__FnwEw","new_envelope_button":"Menu_new_envelope_button__GKw1u"};